module.exports = __webpack_public_path__ + "static/img/logoph.2690af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/logoph.jpg
// module id = fUtV
// module chunks = 6